import { RootState } from 'store';
import { newFilesAdapter } from './newFilesSlice';

export const { selectAll: selectNewFiles } = newFilesAdapter.getSelectors<RootState>(state => state.newFiles);
